import { styledPolymorphic } from '@qred/components-library';

export const CardOptInPage = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(() => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
  }))
);

export const CardOptInContent = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(({ theme }) => ({
    width: '968px',
    maxWidth: '100%',
    display: 'grid',
    gridTemplateRows: 'auto auto auto auto',
    justifySelf: 'center',
    position: 'relative',
    maxHeight: '100%',
    height: '100%',
    gridTemplateColumns: '16px 1fr 16px',
    overflowX: 'clip',

    [theme.fn.largerThan('tablet')]: {
      overflow: 'unset',
      height: 'unset',
      gridTemplateColumns: '1fr 576px 1fr',
    },

    '> :first-child': {
      gridRow: 1,
      gridColumn: 2,
      justifyContent: 'center',
      [theme.fn.largerThan('tablet')]: {},
    },
    '> :nth-child(2)': {
      gridRow: 2,
      gridColumn: 2,
      gridRowEnd: 4,
      [theme.fn.largerThan('tablet')]: {
        marginTop: '24px',
        gridRowEnd: 3,
      },
    },

    '> :nth-child(3)': {
      gridRow: 3,
      gridColumn: 2,
      alignSelf: 'center',

      [theme.fn.largerThan('tablet')]: {
        justifySelf: 'center',
        marginTop: '40px',
      },
    },
  }))
);

export const ContentCard = styledPolymorphic<'div'>()((_styled) =>
  _styled(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column' as const,
    padding: '16px',
    borderRadius: '8px',
    background: theme.fn.themeColor('Container/Option_2_(White)'),
    height: 'fit-content',
    cursor: 'pointer',

    [theme.fn.largerThan('tablet')]: {
      padding: '32px 24px',
    },
  }))
);
